<script>
  import './style.scss';
  import template from './template.html';
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import { ChevronDownIcon } from '../../icons.js';
  import { createPopper } from '@popperjs/core'
  import {isEmpty} from 'lodash';
  import { getterSetterOrderDetailsValue } from '../Order-Details/getter-setter';

  export default {
    template,

    props: {

      orderId: {
        type: [String, Number],
        default: 0
      },

      editMode: {
        type: Boolean,
        default: false
      },

      message: {
        type: String,
        default: ''
      },
      
      onBehalfData: {
        type: [Object, Array],
        default: () => {},
      }
    },

    mounted () {

      const { behalf_account, behalf_user } = this.onBehalfData;
      //get submit on behalf accounts
      this.getAccounts().then(accounts => {
        this.accounts = accounts;
        let account = this.accounts.find(account => account.id == behalf_account);
        this.setBehalfAccount(account.id);
        this.onBehalfAccount = account.id;

        //get default account users
        //@TODO - does this need to run here?
        if (this.isAdminUser) {
          this.getAccountUsers().then(accountUsers => {
            this.accountUsers = accountUsers;

            let authUser = this.accountUsers.find(user => user.id == behalf_user);

            this.setOnBehalfUser(authUser.id);
          })
        } else {
          this.setOnBehalfUser(auth.id);
        }
      });
    },

    watch: {},

    computed: {

      ...mapState({
        coStore: state => state.CreateOrderStore,
      }),

      ...mapGetters('CreateOrderStore', [
        'behalf_account',
        'behalf_user',
      ]),

      ...mapGetters('AuthStore', [
        'isAdminUser',
      ]),

      program: getterSetterOrderDetailsValue('program'),

      /**
      * Check if the user has set a program
      *
      * @return Boolean
      */
      isEmptyProgram() {
        return isEmpty(this.program);
      },

      /**
       * Account users options list with full names
       *
       */
      accountUsersOptions () {
        return this.accountUsers.map(user => {
          let { firstname, lastname } = user;
          return Object.assign({}, user, { fullname: `${firstname} ${lastname}` });
        });
      }
    },

    methods: {

      ...mapMutations('CreateOrderStore', [
        'setBehalfAccount',
        'setBehalfUser',
      ]),

      init () {
        //get uploaded files
        this.getUploadedFiles().then(this.mapUploadedFilesToFilepond);
      },

      /**
       * Get Accounts ( for on behalf submits )
       *
       */
      getAccounts () {
        return axios('/create-order/accounts').then(result => result.data.accounts);
      },

      /**
       * Get Acocunt users ( for on behalf )
       *
       */
      getAccountUsers (account) {
        account = account || this.onBehalfAccount;

        return axios(`/account/${account}/users`)
          .then(result => result.data.data);
      },

      /**
       * update on behalf account
       *
       */
      updateOnBehalfAccount ($event) {
        this.setBehalfAccount($event);
        this.onBehalfAccount = $event;
        this.$emit('set-behalf-account', $event);

        this.$nextTick(() => {
          this.getAccountUsers().then(accountUsers => {
            this.accountUsers = accountUsers;

            //check if current auth user is in the list of accountUsers
            let authUser = this.accountUsers.find(user => user.id == auth.id);
            let userId = authUser ? auth.id : '';

            this.setOnBehalfUser(userId);
          })
        });
      },

      setOnBehalfUser($event) {
        this.setBehalfUser($event);
        this.onBehalfUser = $event;
        if($event !== '') {
          this.$emit('on-behalf-set', $event);
        }
      },

      //checks if we are updating an existing(new) order
      isNewOrder () {
        return !isEmpty(this.orderId);
      },

      /**
       *
       * @return boolean
       */
      filesUploading () {
        let isUploading = false;

        if (this.filepondReady) {
          let perct = this.uploadingFiles().perct;
          isUploading = perct >= 1 && perct < 100;
        }

        return isUploading;
      },

      withPopper(dropdownList, component, { width }) {
        /**
         * We need to explicitly define the dropdown width since
         * it is usually inherited from the parent with CSS.
         */
        dropdownList.style.width = width

        /**
         * Here we position the dropdownList relative to the $refs.toggle Element.
         *
         * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
         * the dropdownList overlap by 1 pixel.
         *
         * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
         * wrapper so that we can set some styles for when the dropdown is placed
         * above.
         */
        const popper = createPopper(component.$refs.toggle, dropdownList, {
          placement: 'top',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -1],
              },
            },
            {
              name: 'toggleClass',
              enabled: true,
              phase: 'write',
              fn({ state }) {
                component.$el.classList.toggle(
                  'drop-up',
                  state.placement === 'top'
                )
              },
            },
          ],
        })

        /**
         * To prevent memory leaks Popper needs to be destroyed.
         * If you return function, it will be called just before dropdown is removed from DOM.
         */
        return () => popper.destroy()
      },
    },

    data () {

      let selected = Object.assign({}, this.selected);

      return {
        account: window.backend.account,
        isVisible: false,
        statusTimestamp: '',
        accounts: [],
        accountUsers: [],
        selectedItem: selected,
        onBehalfUser: '',
        onBehalfAccount: '',
      }
    },

    components: {
      ChevronDownIcon
    },

    directives: {},

    created () {
      //this.selectedItem = this.items[0];
    }
  }
</script>
